import { ReactNode } from 'react';
import Box from '@mui/material/Box';

// Vänsterspalten (260 px) och en textkolumn på ungefär 800 px, så att raderna går att läsa även på breda skärmar.
const HELP_CENTER_MAX_WIDTH = 1100;

type HelpCenterFrameProps = {
  children: ReactNode;
};

/**
 * Hjälpcentrets gemensamma ram: högst 1100 px bred och centrerad, så att startsidan och artikel-, kategori- och
 * söksidorna har samma kanter.
 */
export const HelpCenterFrame = (props: HelpCenterFrameProps) => {
  const { children } = props;

  return <Box sx={{ maxWidth: HELP_CENTER_MAX_WIDTH, mx: 'auto' }}>{children}</Box>;
};
